export class LogoutSuccess {
  public static readonly type = '[Authentication] LogoutSuccess';
}
